import { api, currentCreche } from '../api'

const StaffAttendanceRepository = {

    getAll (query = { }) {
        return api().$get(`/${currentCreche().uuid}/staff-attendances`, query)
    },

    index (staffUuid, query = {}) {
        return api().$get(`/${currentCreche().uuid}/staff/${staffUuid}/attendances`, query)
    },

    store (staffUuid, payload) {
        return api().$post(`/${currentCreche().uuid}/staff/${staffUuid}/attendances`, payload)
    },

    update (staffUuid, attendanceUuid, payload) {
        return api().$put(`/${currentCreche().uuid}/staff/${staffUuid}/attendances/${attendanceUuid}`, payload)
    },

    delete (staffUuid, attendanceUuid) {
        return api().$delete(`/${currentCreche().uuid}/staff/${staffUuid}/attendances/${attendanceUuid}`)
    },

    specificPeriod (staffUuid, payload) {
        return api().$post(`/${currentCreche().uuid}/staff/${staffUuid}/specific-schedule`, payload)
    },

    printWeek (payload = {}) {
        return api().$get(`/${currentCreche().uuid}/staff-attendance/week/print`, payload, {
            responseType: 'blob'
        })
    }
}

export default StaffAttendanceRepository
